import { Box, HStack, useTheme } from 'native-base';
import { VictoryAxis, VictoryBar, VictoryChart, VictoryGroup, VictoryLabel } from 'victory';
import { useTranslation } from 'react-i18next';

import { Text } from '@pimm/base';

type ProgressBarCardProps = {
  _container?: React.ComponentProps<typeof Box>;
  title: string;
  weeklySummary?: {
    day?: string;
    completion?: number;
  }[];
};

export const ProgressBarCard = ({ _container, title, weeklySummary = [] }: ProgressBarCardProps) => {
  const { colors } = useTheme();
  const { t } = useTranslation();

  return (
    <Box {..._container}>
      <Box rounded="xl" borderWidth={1} bg="gray.25" bgColor="white">
        <HStack alignItems="center" justifyContent="space-between" py={3} px={4} borderBottomWidth={1}>
          <Text size="lg" fontWeight={700} color="gray.900" textTransform="uppercase" lineHeight="xs">
            {title}
          </Text>
        </HStack>

        <VictoryChart
          height={140}
          domainPadding={{ x: [50, 50] }}
          padding={{ top: 20, left: 40, bottom: 20, right: 10 }}
          theme={{
            chart: {},
            axis: {
              style: {
                grid: { stroke: 0 },
                axisLabel: {
                  fontFamily: "'Inter', sans-serif",
                  fontWeight: 600,
                  fontSize: 7,
                  padding: 20,
                },
                tickLabels: {
                  paddingTop: 0,
                  fontFamily: "'Inter', sans-serif",
                  fontWeight: 500,
                  fontSize: 7,
                },
              },
            },
          }}
        >
          <VictoryAxis
            tickValues={weeklySummary.map(d => d.day)}
            tickLabelComponent={<VictoryLabel dy={2} />}
            style={{
              axis: { stroke: colors.gray[100] },
              tickLabels: { padding: 2 },
            }}
          />
          <VictoryAxis
            dependentAxis
            tickValues={[0, 20, 40, 60, 80, 100]}
            tickLabelComponent={<VictoryLabel dx={-5} />}
            label={t('app_insights:completion')}
            labelComponent={<VictoryLabel />}
            style={{
              axis: { stroke: 'transparent' },
              grid: { stroke: colors.gray[100] },
              tickLabels: { padding: 2 },
            }}
            domain={[0, 100]}
          />
          <VictoryGroup>
            <VictoryBar
              data={weeklySummary}
              x="day"
              y="completion"
              barWidth={10}
              cornerRadius={{ top: 3 }}
              style={{
                data: {
                  fill: ({ datum }) =>
                    datum.completion === 0 ? 'transparent' : datum.completion === 100 ? colors.blueLight[500] : colors.warning[400],
                },
              }}
            />
          </VictoryGroup>
        </VictoryChart>
      </Box>
    </Box>
  );
};
